<div class="common-style add-services-to-group-dialog">
  <button type="button" mat-icon-button class="add-popup-close" (click)="onCancel()">
    <mat-icon class="material-symbols-outlined">close</mat-icon>
  </button>
  <h3 class="model-title">Associate Services</h3>

  <mat-dialog-content class="mt-0 form">
    <div class="services-selection-container p-relative">

      <!-- Loading Spinner -->
      @if (isLoading) {
        <div class="d-flex justify-content-center align-items-center p-5">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }

      @if (!isLoading) {
        @if (services.length > 0) {
          <div class="service-search-row">
            <div class="service-search-wrap">
              <input
                type="text"
                class="service-search-input"
                [value]="serviceSearchQuery"
                placeholder="Search services..."
                (input)="onServiceSearchInput($event)" />
              @if (!hasActiveServiceSearch) {
                <mat-icon class="service-search-icon" aria-hidden="true">search</mat-icon>
              } @else {
                <button
                  type="button"
                  class="service-search-clear"
                  aria-label="Clear search"
                  (click)="clearServiceSearch()">
                  <mat-icon aria-hidden="true">close</mat-icon>
                </button>
              }
            </div>
          </div>

          <!-- Select All Header -->
          <div class="select-all-header">
            <mat-checkbox tabIndex="0" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"
              (keydown.enter)="onSelectAllEnter($event)"
              (change)="toggleAll($event)">
              Select All
            </mat-checkbox>
            <span class="selected-count text-muted">{{ selectedCount }} selected</span>
          </div>
        }
        <!-- Services List -->
        @if (services.length > 0) {
          @if (hasServiceSearchResults) {
            <div class="services-list">
              @for (service of filteredServices; track service.id) {
                <div class="service-item"
                  (click)="toggleService(service)"
                  [class.selected]="service.selected">
                  <div class="service-checkbox">
                    <mat-checkbox tabIndex="0" [checked]="service.selected" (click)="$event.stopPropagation()"
                      (keydown.enter)="onServiceCheckboxEnter($event, service)"
                      (change)="toggleService(service)">
                    </mat-checkbox>
                  </div>
                  <div class="service-info flex-grow-1">
                    <div class="service-name">{{ service.name }}</div>
                    @if (service.description) {
                      <div class="service-description">
                        {{ service.description }}
                      </div>
                    }
                  </div>
                  <div class="service-status">
                    <div class="status-badge status-{{ service.status | serviceStatus:'class' }}">
                      <span class="status-dot"></span>
                      {{ service.status | serviceStatus }}
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else if (hasActiveServiceSearch) {
            <div class="no-services-message">
              <p class="mb-0">No matching services found.</p>
            </div>
          }
        } @else {
          <div class="no-services-message">
            <p class="mb-0">No services available to add. All services are either already in this group or
            no standalone services exist.</p>
          </div>
        }
        <!-- No Services Available -->
      }
    </div>
  </mat-dialog-content>

  <div class="modal-action mt-auto">
    <button type="button" class="bt-border" mat-raised-button (click)="onCancel()">Cancel</button>
    <button type="button" class="bt-background ms-5" mat-raised-button (click)="onAddServices()"
      [disabled]="selectedCount === 0">
      Associate {{ selectedCount > 0 ? selectedCount : '' }} Service{{ selectedCount !== 1 ? 's' : '' }}
    </button>
  </div>
</div>
